import {VARIANT_STATE_SELECTED} from '@packages/systems/designer/actions';
import {VariantStateKey} from '@packages/systems/style-legacy/selectors';
import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const variantStateSelected: ActionCreator<
  typeof VARIANT_STATE_SELECTED,
  VariantStateKey | null
> = createAction(VARIANT_STATE_SELECTED);
